import dynamic from 'next/dynamic';
import React from 'react';
const PricingPage = dynamic(() => import('@/components/PricingPage'), {
  ssr: false,
});

const Pricing = () => {
  return <PricingPage />;
};

export default Pricing;
